import { getActionStringWithoutState } from '@redux/reduxUtils';
import { ReduxState } from '@redux/types';
import { getSystemPromptCategoriesAction } from './caregiverAssistantActions';
import { CaregiverAssistantState, SystemPromptCategory } from './caregiverAssistantTypes';

export const getCaregiverAssistantStateSelector = (state: ReduxState): CaregiverAssistantState => {
  return state.caregiverAssistant;
};

export const getSystemPromptCategoriesSelector = (state: ReduxState): SystemPromptCategory[] => {
  return getCaregiverAssistantStateSelector(state).systemPromptCategories;
};

export const getIsLoadingSelector = (state: ReduxState): Record<string, boolean> => {
  return getCaregiverAssistantStateSelector(state).isLoading;
};

export const isLoadingSystemPromptCategoriesSelector = (state: ReduxState): boolean => {
  const tag = getActionStringWithoutState(getSystemPromptCategoriesAction.start.type);
  return getIsLoadingSelector(state)[tag] || false;
};

export const getErrorSelector = (state: ReduxState) => {
  return getCaregiverAssistantStateSelector(state).error;
};

export const getSuccessSelector = (state: ReduxState) => {
  return getCaregiverAssistantStateSelector(state).success;
};
